import React from 'react';
import { Badge, Card, CardBody, Collapse, FormGroup, Input, Label } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CategoryAccordion = ({
  handleCategories,
  index,
  isOpen,
  items,
  length,
  selectedCategories,
  toggleAccordion,
  title
}) => {
  if (!items) {
    return;
  }

  let panelStyle = 'panel-collapse';
  if (index === 0) {
    panelStyle += ' panel-collapse-first';
  } else if (index === length - 1) {
    panelStyle += ' panel-collapse-last';
  }

  const numItemsChecked = items.filter(item => selectedCategories.has(item.id)).length;

  // eslint-disable-next-line consistent-return
  return (
    <div className={panelStyle}>
      <div
        className="d-flex justify-content-between"
        onClick={() => toggleAccordion(index)}
        onKeyDown={() => toggleAccordion(index)}
        tabIndex="0"
        role="button"
      >
        <h3>{title}</h3>
        <div className="mb-2">
          {!isOpen && numItemsChecked > 0 && (
            <Badge className="mr-2 mt-0 pt-1 px-2" color="primary">
              {numItemsChecked}
            </Badge>
          )}
          <FontAwesomeIcon icon={isOpen ? 'chevron-circle-up' : 'chevron-circle-down'} />
        </div>
      </div>

      <Collapse isOpen={isOpen}>
        <Card className="px-1">
          <CardBody>
            {items
              && items.map(item => (
                <FormGroup key={item.id} check>
                  <Label check>
                    <Input
                      type="checkbox"
                      checked={selectedCategories.has(item.id)}
                      value={item.id}
                      onChange={e => handleCategories(e)}
                    />
                    <p>{item.name}</p>
                  </Label>
                </FormGroup>
              ))}
          </CardBody>
        </Card>
      </Collapse>
    </div>
  );
};

export default CategoryAccordion;
